import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggerComponent } from './components/logger/logger.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    LoggerComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    LoggerComponent
  ]
})
export class LoggerModule { }
